import { render, staticRenderFns } from "./PickerOrderItemSection.vue?vue&type=template&id=ec2269f4&scoped=true&"
import script from "./PickerOrderItemSection.ts?vue&type=script&lang=js&"
export * from "./PickerOrderItemSection.ts?vue&type=script&lang=js&"
import style0 from "./PickerOrderItemSection.vue?vue&type=style&index=0&id=ec2269f4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec2269f4",
  null
  
)

export default component.exports